import dateFormat from 'date-fns/format';

export default{
	filters: {
		formatDate: (value, format) => dateFormat(value, format)
	}
}